// extracted by mini-css-extract-plugin
module.exports = {"field":"TrIkF","label":"A2COV","value":"yHD48"};